import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Card, Spin, Space, Switch, Button, Input, Select } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useParams, Link } from 'react-router-dom';
import SwaggerUI from 'swagger-ui-react';
import { connect } from 'react-redux'
import { getApiDetail } from '../../../apis/apis';
import AdminLayoutWrapper from '../AdminLayoutWrapper';
import { updatePrivacyApis, updateExternalPath, updateScopeApis } from '../../../apis/apis';
import MethodTag from '../../Method';
import EditInput from '../../common/EditInput';
import MultiSelect from '../../common/MultiSelect';

const styles = {
  'primaryLabel': {
    fontSize: 18,
    fontWeight: 700
  },
  secondLabel: {
    fontSize: 16,
    fontWeight: 400
  }
}

const { Option } = Select;

const ApiDetail = ({ user }) => {

  const [apiDetail, setDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const scopeList = user?.scope?.data || [];

  const inputRef = useRef(null);

  const { id } = useParams();

  const requestGetApiDetail = async (id) => {
    const res = await getApiDetail(id);
    if (res.scopes) {
      res.scopes = res.scopes.map((scope) => scope.scopeId);
    }
    return res
  }

  const fetchApiDetail = useCallback(async () => {
    try {
      if (id ?? false) {
        setLoading(true);
        const apiRes = await requestGetApiDetail(id);
        setDetail(apiRes);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, [id])

  useEffect(() => {
    fetchApiDetail();
  }, [fetchApiDetail]);

  const updateScope = async (nextValue, group, targetId) => {
    try {
      setLoading(true);
      if (group === 'apis') {
        await updatePrivacyApis(id, {
          public: nextValue
        });
        const apiRes = await requestGetApiDetail(id);
        setDetail(apiRes);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }


  const handleSubmitPath = async () => {
    console.log(inputRef?.current?.state?.value);
    try {
      setLoading(true);
      const resp = await updateExternalPath(apiDetail.id, {
        external_path: inputRef?.current?.state?.value || apiDetail.externalPath
      });
      setDetail((prev) => {
        return {
          ...prev,
          externalPath: resp.externalPath || inputRef?.current?.state?.value
        }
      });
      setLoading(false);
      // call api get detail 
      await fetchApiDetail();
    } catch (error) {
      setLoading(false);
      console.log('error', error);
    }
  }

  const handleSubmitSelect = async (body) => {
    try {
      setLoading(true);
      const res = await updateScopeApis(id, { scope_ids: body });
      if (res.scopes) {
        res.scopes = res.scopes.map((scope) => scope.scopeId);
      }
      setDetail({
        ...apiDetail,
        scopes: res?.scopes
      })
      setLoading(false);
    } catch (error) {
      setLoading(false)
    }
  }

  return (
    <AdminLayoutWrapper>
      <Spin spinning={loading}>
        <div>
          <Button type="primary" size="large">
            <Link to={`/admin/api-docs/${apiDetail?.apiDocId}`}><ArrowLeftOutlined /> Back</Link>
          </Button>
        </div>
        <br></br>
        <div>
          {
            apiDetail?.path &&
            (<div>
              <Card title={<p style={{ ...styles.primaryLabel, marginBottom: 0 }}>{apiDetail.path}</p>}>
                <div>
                  <Space>
                    <p style={styles.primaryLabel}>Status:</p>
                    <p>
                      <Switch
                        checkedChildren="Public"
                        unCheckedChildren="Private"
                        defaultChecked={false}
                        checked={apiDetail.isPublic}
                        onChange={(checked) => {
                          updateScope(checked, 'apis')
                        }}
                      />
                    </p>
                  </Space>
                </div>
                <div>
                  <Space>
                    <p style={styles.primaryLabel}>Method:</p>
                    <p>
                      <MethodTag style={styles.secondLabel} method={apiDetail.method} />
                    </p>
                  </Space>
                </div>
                <div>
                  <Space>
                    <EditInput
                      labelStyle={styles.primaryLabel}
                      contentStyle={styles.secondLabel}
                      inputRef={inputRef}
                      onSubmit={handleSubmitPath}
                      value={apiDetail.externalPath}
                      labelValue="External Path : "
                    />
                  </Space>
                </div>
                {
                  scopeList && scopeList.length > 0
                  && (<div>
                      <Space>
                        <MultiSelect
                          labelStyle={styles.primaryLabel}
                          options={scopeList}
                          value={apiDetail?.scopes || []}
                          onSubmit={handleSubmitSelect}
                        />
                      </Space>
                    </div>)
                }
              </Card>
            </div>)
          }
        </div>
        <Card>
          {
            apiDetail && apiDetail.combinedContent && <SwaggerUI spec={JSON.parse(apiDetail.combinedContent)} />
          }
        </Card>
      </Spin>

    </AdminLayoutWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.app.user
  }
}

export default connect(mapStateToProps, null)(ApiDetail);